export default __webpack_public_path__ + "static/media/project_arrow.13b0250f.svg";